import { RestaurantPropType } from "../../home/types";
import FavouriteButton from "../../favourites/component/FavouriteButton";

type PropType = {
  restaurant: RestaurantPropType;
  onClick: (restaurant: RestaurantPropType) => void;
  onToggle: (data: any) => void;
};

const MoreRestaurantCard = ({ restaurant, onClick, onToggle }: PropType) => {
  return (
    <div className="relative border rounded-lg p-1 flex flex-col gap-2">
      {restaurant!.is_open === false && (
        <div
          className="absolute rounded-lg flex items-center justify-center top-0 bottom-0 left-0 right-0 bg-trans"
          onClick={() => onClick(restaurant)}
        >
          <div className="font-medium text-base text-white">
            Temporarily Closed
          </div>
        </div>
      )}
      <div
        className="h-[150px] bg-grey bg-cover bg-no-repeat"
        onClick={() => onClick(restaurant)}
        style={{ backgroundImage: `url(${restaurant.cover_photo})` }}
      ></div>
      <div className="flex flex-col gap-3 p-2">
        <div className="flex items-center justify-between">
          <div
            className="text-sm font-medium w-full"
            onClick={() => onClick(restaurant)}
          >
            {restaurant.name}
          </div>
          <FavouriteButton onToggle={onToggle} isFav={restaurant.isFavourite} />
        </div>
        <div
          className="flex items-center justify-between"
          onClick={() => onClick(restaurant)}
        >
          <div className="text-blue font-normal text-xs bg-blue/5 p-2">
            {restaurant.delivery_time} mins
          </div>
          <div className="text-[#727272] font-medium text-xs">
            {restaurant.rating}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreRestaurantCard;
